import * as _ from 'lodash';

import { AssetClassColourArray, AssetClassNameArray } from "./enums/AssetClassType";
import { PortfolioUtilities } from './portfolio.utilities';

class AssetClassListController implements angular.IOnInit, angular.IOnChanges {
  public assetClasses: { name: string, total: number }[]//AssetClassTotal[]
  public displayCurrency: string; // Possible Enum: DisplayCurrencies or Currencies
  public showIndicators: boolean;

  public assetClassesTotal: number;

  /** @ngInject */
  constructor(private portfolioUtilities: PortfolioUtilities) { }

  $onInit(): void {
    if (this.assetClasses)
      this.assetClassesTotal = this.assetClasses.reduce((total, current) => total + current.total, 0);
  }

  $onChanges(onChangesObj: angular.IOnChangesObject): void {
    if (onChangesObj.assetClasses &&
      onChangesObj.assetClasses.currentValue)
      this.assetClassesTotal = this.assetClasses.reduce((total, current) => total + current.total, 0);
  }

  getAssetClassColour(assetClass: string) {
    return AssetClassColourArray[AssetClassNameArray.indexOf(assetClass)]
  }

  public formatCurrency() {
    return this.portfolioUtilities.formatCurrency(this.displayCurrency);
  }

  public formatName(name: string) {
    return _.startCase(name);
  }

  public getAssetClassPercentage(assetClass: { name: string, total: number }) {
    return (assetClass.total / this.assetClassesTotal) * 100;
  }
}

export const assetClassList: angular.IComponentOptions = {
  controller: AssetClassListController,
  template: require('./assetClassList.component.html'),
  bindings: {
    assetClasses: '<',
    displayCurrency: '<',
    showIndicators: '<'
  }
}



// WEBPACK FOOTER //
// ./src/app/common/assetClassList.component.ts